"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentModel = void 0;
var PaymentModel = /** @class */ (function () {
    function PaymentModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/crm/payments",
            UPDATE: APPURL + "/api/v1/crm/payments",
            CREATE: APPURL + "/api/v1/crm/payments",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    PaymentModel.prototype.extract = function (result) {
        return result.data;
    };
    PaymentModel.prototype.cacheResults = function (result) {
        return this.extract(result);
    };
    PaymentModel.prototype.show = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    PaymentModel.prototype.delete = function (data) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + data.id)
            .then(this.cacheResults);
    };
    PaymentModel.prototype.voidPayment = function (payment_id) {
        return this.$http
            .post("".concat(this.URLS.FETCH, "/").concat(payment_id, "/void"), {})
            .then(this.cacheResults);
    };
    PaymentModel.prototype.refundPayment = function (student_id, payment_id, amount, last4, expiration_date, expiration_month, expiration_year, lifecycle) {
        if (amount === void 0) { amount = null; }
        if (last4 === void 0) { last4 = null; }
        if (expiration_date === void 0) { expiration_date = null; }
        if (expiration_month === void 0) { expiration_month = null; }
        if (expiration_year === void 0) { expiration_year = null; }
        if (lifecycle === void 0) { lifecycle = {}; }
        return this.$http.post("".concat(this.APPURL, "/api/v1/users/students/").concat(student_id, "/payments/").concat(payment_id, "/refund"), __assign(__assign(__assign({ payment_id: payment_id }, (amount !== null ? { amount: amount } : {})), { last4: last4, expiration_date: expiration_date, expiration_month: expiration_month, expiration_year: expiration_year }), lifecycle)).then(this.cacheResults);
    };
    return PaymentModel;
}());
exports.PaymentModel = PaymentModel;
PaymentModel.$inject = ["$http", "APPURL"];
exports.default = PaymentModel;
